import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { copyText } from '@utils/helpers';
import { BehaviorSubject } from 'rxjs';
import Timeout = NodeJS.Timeout;
import { isNullish } from '@utils/is-nullish.tool';

@Component({
	selector: 'app-clipboard-copy',
	templateUrl: './clipboard-copy.component.html',
	styleUrls: ['./clipboard-copy.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClipboardCopyComponent {
	@Input() text: string | number | null;
	@Input() outlineView: boolean;

	isCopied$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private _timeoutId: Timeout;
	private _SHOW_TIME = 1500;

	public copyToClipboard(event: MouseEvent): void {
		event.stopPropagation();
		if (isNullish(this.text) || this._timeoutId) {
			return;
		}
		copyText(this.text);
		this.isCopied$.next(true);
		this._timeoutId = setTimeout(() => {
			this.isCopied$.next(false);
			this._timeoutId = null;
		}, this._SHOW_TIME);
	}
}
